import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { BlogRenderer } from '../components/BlogRenderer';
import { blogData } from '../data/blogData';
import { ChevronRight } from 'lucide-react';

const BlogDetail = () => {
    const { slug } = useParams();
    const blog = blogData.find(b => b.slug === slug);

    if (!blog) {
        return <div className="min-h-screen flex items-center justify-center text-xl">Blog not found</div>;
    }

    return (
        <main className="bg-[#ffffff] text-black min-h-screen pb-20">
            {/* Hero Section */}
            <div className="relative h-[60vh] min-h-[400px]">
                <div className="absolute inset-0">
                    <img
                        src={blog.heroImage}
                        alt="Blog Hero"
                        className="w-full h-full object-cover opacity-60"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0f1720] via-transparent to-transparent" />
                </div>

                <div className="relative z-10 flex h-full items-end justify-center pb-16 px-6">
                    <h1 className="max-w-5xl text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-center tracking-tight text-white">
                        {blog.title}
                    </h1>
                </div>
            </div>

            {/* Breadcrumb */}
            <div className="max-w-5xl mx-auto px-4 py-8">
                <nav className="flex items-center space-x-2 text-sm text-gray-400">
                    {blog.breadcrumb.map((item, index) => (
                        <React.Fragment key={index}>
                            <span className="hover:text-black transition-colors cursor-pointer">{item}</span>
                            {index < blog.breadcrumb.length - 1 && (
                                <ChevronRight className="w-4 h-4" />
                            )}
                        </React.Fragment>
                    ))}
                </nav>
            </div>

            {/* Content Renderer */}
            <BlogRenderer content={blog.content} />
        </main>
    );
};

export default BlogDetail;
